import "yuki-createjs";

// tslint:disable-next-line:no-var-requires
require("src/assets/css/style.css")

import * as $ from "jquery";
import Utils from "lib/src/utils";
import Kleurplaat from "src/Kleurplaat";
import Globals from "lib/src/Globals";

const FPS = 30;

const $window = $(window);
$window.ready(() => {
    const canvas = document.getElementById("canvas") as HTMLCanvasElement;

    canvas.width = $window.width();
    canvas.height = $window.height();
    Utils.init(canvas);

    Globals.gameId = "coloring";

    new Kleurplaat().start(canvas);

    createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
    createjs.Ticker.framerate = FPS;
});



// WEBPACK FOOTER //
// ./~/string-replace-webpack-plugin/loader.js?id=n13pcaxlbhf!./src/main.ts